import styled, { keyframes } from "styled-components";

const copyPulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
`;

export const Content = styled.div`
    background-color: #FFFFFF;
    border-radius: 8px;
    padding: 24px;
    display: flex;
    flex-direction:row;
    gap: 16px;
`;

export const Body = styled.div`
    display: grid;
    gap: 16px;
    grid-template:
        "fields fields fields"
        "responsavel responsavel instagram"
        "saler saler .";
    grid-template-columns: repeat(3, 1fr);
`;

export const BodyImage = styled.div`
    display:flex;
    flex-direction:column;
    align-items:center;

    .buttttton{
        align-items:center;
    }
`

export const EditPerfilFirstLineFields = styled.div`
    display: grid;
    gap: 16px;
    grid-template:
        "name name username"
        "checkbox checkbox ."
        "email phone whatsapp";
    grid-template-columns: repeat(3, 1fr);
    grid-area: fields;
    width: 100%;

    > div:nth-child(1) { grid-area: name; }
    > div:nth-child(2) { grid-area: username; }
    > div:nth-child(3) { grid-area: checkbox; display:flex; align-items:center; }
    > div:nth-child(4) { grid-area: email; }
    > div:nth-child(5) { grid-area: phone; }
    > div:nth-child(6) { grid-area: whatsapp; }
`

export const DefaultInputInclude = styled.div`
    flex-direction: column;
    display: flex;
    gap: 4px;

    > div {
        border: ${({ borderColor }) => borderColor && `1px solid ${borderColor}`};
    }

    > span {
        font-family: "Poppins";
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 16px;
        color: #3d3d3d;
        height: 16px;
    }
`

export const CheckoutInputInclude = styled.div`
    display: flex;
    flex-direction: row;
    gap: 4px;

    > * {
        width: 50%;
    }
    
    > span {
        font-family: "Poppins";
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 16px;
        color: #3d3d3d;
        height: 16px;
    }
`

export const CopyIconStyled = styled.div`
    animation: ${props => props.isAnimating ? copyPulse : 'none'} 0.4s ease-in-out;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s ease;
    
    &:hover {
        color: #7a7a7a;
    }
`